"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const eventConstants_1 = require("../../constants/eventConstants");
const actionsSlice_1 = require("../../features/actions/actionsSlice");
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const styles_1 = __importDefault(require("../../styles/styles"));
const button_1 = __importDefault(require("../button/button"));
const icon_1 = __importDefault(require("../icon/icon"));
const messageModalConstant_1 = require("./messageModalConstant");
const MessageModal = ({ message, type }) => {
    const dispatch = useAppDispatch_1.default();
    const [modalVisible, setModalVisible] = react_1.useState(true);
    const modalBody = messageModalConstant_1.MESSAGE_MODAL_BODY[type];
    const onDismiss = () => {
        // Reset the action state to remove errors.
        dispatch(actionsSlice_1.resetActionState());
        setModalVisible(false);
    };
    return (react_1.default.createElement(react_native_paper_1.Portal, null,
        react_1.default.createElement(react_native_paper_1.Modal, { visible: modalVisible, dismissable: false, contentContainerStyle: styles_1.default.centerChilds, theme: {
                colors: {
                    backdrop: 'transparent',
                },
            } },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.centeredView },
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.modalView },
                    react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
                        react_1.default.createElement(icon_1.default, { icon: modalBody.icon, color: modalBody.color, size: 50 })),
                    react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.textColorBlack, styles_1.default.marginFive] }, modalBody.title),
                    react_1.default.createElement(react_native_1.Text, { style: styles_1.default.modalText }, message),
                    react_1.default.createElement(button_1.default, { text: "Ok", onPress: onDismiss, eventName: eventConstants_1.DISMISS_MESSAGE_MODAL }))))));
};
exports.default = MessageModal;
